module.exports = __webpack_public_path__ + "static/media/Thailand-mobile.4a4e8834.jpg";